var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"usermanagetable"},[_c('el-table',{staticStyle:{"width":"100%","padding":"10px 10px 0 10px"},attrs:{"data":_vm.tableData,"border":""}},[_c('el-table-column',{attrs:{"prop":"createAtMY","label":"时间"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"createUserInfoName","label":"用户"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }